module.exports = __webpack_public_path__ + "img/loginLeftImg.4005599b.png";